import { createTheme } from "@mui/material/styles";
import { PaletteMode } from "@mui/material";

declare module "@mui/material/styles" {
  interface Theme {
    myTheme: {
      colors: {
        white: string;
        black: string;
        bg: string;

        background100: string;
        background90: string;
        background80: string;
        background50: string;
        background20: string;
        background10: string;

        foreground100: string;
        foreground90: string;
        foreground80: string;
        foreground50: string;
        foreground20: string;
        foreground10: string;

        primary100: string;
        primary90: string;
        primary80: string;
        primary50: string;
        primary20: string;

        secondary: string;
        tertiary: string;
        destructive: string;
        alert: string;
        success: string;

        gray100: string;
        gray200: string;
        gray300: string;
        gray400: string;
        gray500: string;
        gray600: string;

        graphLines: string;
      };
    };
  }
  interface ThemeOptions {
    myTheme?: {
      colors: {
        white: string;
        black: string;
        bg: string;

        background100: string;
        background90: string;
        background80: string;
        background50: string;
        background20: string;
        background10: string;

        foreground100: string;
        foreground90: string;
        foreground80: string;
        foreground50: string;
        foreground20: string;
        foreground10: string;

        primary100: string;
        primary90: string;
        primary80: string;
        primary50: string;
        primary20: string;

        secondary: string;
        tertiary: string;
        destructive: string;
        alert: string;
        success: string;

        gray100: string;
        gray200: string;
        gray300: string;
        gray400: string;
        gray500: string;
        gray600: string;

        graphLines: string;
      };
    };
  }
}
const AdronTheme = (mode: PaletteMode) => {
  return createTheme({
    myTheme: {
      colors: {
        white: "rgba(255, 255, 255, 1)",
        black: "rgba(0, 0, 0, 1)",
        bg: mode === "dark" ? "rgba(13, 16, 18, 1)" : "rgba(245, 245, 245, 1)",

        background100: mode === "dark" ? "rgba(0, 0, 0, 1)" : "rgba(241, 240, 246, 1)",
        background90: mode === "dark" ? "rgba(0, 0, 0, 0.9)" : "rgba(241, 240, 246, 0.9)",
        background80: mode === "dark" ? "rgba(0, 0, 0, 0.8)" : "rgba(241, 240, 246, 0.8)",
        background50: mode === "dark" ? "rgba(0, 0, 0, 0.5)" : "rgba(241, 240, 246, 0.5)",
        background20: mode === "dark" ? "rgba(0, 0, 0, 0.2)" : "rgba(241, 240, 246, 0.2)",
        background10: mode === "dark" ? "rgba(0, 0, 0, 0.1)" : "rgba(241, 240, 246, 0.1)",

        foreground100: mode === "dark" ? "rgba(255, 255, 255, 1)" : "rgba(21, 21, 21, 1)",
        foreground90: mode === "dark" ? "rgba(255, 255, 255, 0.9)" : "rgba(21, 21, 21, 0.9)",
        foreground80: mode === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(21, 21, 21, 0.8)",
        foreground50: mode === "dark" ? "rgba(255, 255, 255, 0.5)" : "rgba(21, 21, 21, 0.5)",
        foreground20: mode === "dark" ? "rgba(255, 255, 255, 0.2)" : "rgba(21, 21, 21, 0.2)",
        foreground10: mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(21, 21, 21, 0.1)",

        primary100: "rgba(117, 67, 255, 1)",
        primary90: "rgba(117, 67, 255, 0.9)",
        primary80: "rgba(117, 67, 255, 0.8)",
        primary50: "rgba(117, 67, 255, 0.5)",
        primary20: "rgba(117, 67, 255, 0.2)",

        secondary: mode === "dark" ? "rgba(59, 45, 103, 1)" : "rgba(225, 212, 255, 1)",
        tertiary: mode === "dark" ? "rgba(58, 24, 144, 1)" : "rgba(216, 209, 233, 1)",
        destructive: mode === "dark" ? "rgba(239, 68, 68, 1)" : "rgba(241, 0, 0, 1)",
        alert: mode === "dark" ? "rgba(162, 255, 0, 1)" : "rgba(167, 229, 10, 1)",
        success: mode === "dark" ? "rgba(4, 213, 56, 1)" : "rgba(4, 213, 56, 1)",

        gray100: mode === "dark" ? "rgba(148, 148, 150, 1)" : "rgba(148, 148, 150, 1)",
        gray200: mode === "dark" ? "rgba(95, 95, 95, 1)" : "rgba(83, 83, 83, 1)",
        gray300: mode === "dark" ? "rgba(41, 42, 45, 1)" : "rgba(255, 255, 255, 1)",
        gray400: mode === "dark" ? "rgba(34, 35, 38, 1)" : "rgba(236, 237, 241, 1)",
        gray500: mode === "dark" ? "rgba(29, 30, 32, 1)" : "rgba(228, 228, 228, 1)",
        gray600: mode === "dark" ? "rgba(19, 20, 22, 1)" : "rgba(214, 214, 214, 1)",

        graphLines: mode === "dark" ? "rgba(40, 40, 40, 1)" : "rgba(232, 232, 232, 1)",
      },
    },
    shape: {
      borderRadius: 8,
    },
    palette: {
      background: {
        default: mode === "dark" ? "#0D1012" : "#F5F5F5",
        paper: mode === "dark" ? "#3A1890" : "#D8D1E9",
      },
      mode: mode,
      secondary: {
        main: mode === "dark" ? "#3B2D67" : "#E1D4FF",
        light: "#fff",
        dark: "#000",
        contrastText: mode === "dark" ? "#fff" : "#151515",
      },
      text: {
        primary: mode === "dark" ? "#fff" : "#151515",
        secondary: mode === "dark" ? "#fff" : "#000",
      },
      primary: {
        main: "#7543FF",
        light: "#7543FF",
        dark: "#7543FF",
        contrastText: mode === "dark" ? "#fff" : "#151515",
      },
      grey: {
        100: mode === "dark" ? "#949496 !important" : "#949496 !important",
        200: mode === "dark" ? "#5F5F5F" : "#fff",
        300: mode === "dark" ? "#292A2D" : "#fff",
        400: mode === "dark" ? "#222326" : "#ECEDF1",
        500: mode === "dark" ? "#1D1E20" : "#E4E4E4",
        600: mode === "dark" ? "#131416" : "#D6D6D6",
      },
    },
    typography: {
      fontFamily: "Open Sans, sans-serif",
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
    components: {
      MuiButtonBase: {
        // '&.Mui-b': {}
      },
    },
    transitions: {
      duration: {
        shortest: 150,
        shorter: 200,
        short: 250,
        // most basic recommended timing
        standard: 200,
        // this is to be used in complex animations
        complex: 375,
        // recommended when something is entering screen
        enteringScreen: 225,
        // recommended when something is leaving screen
        leavingScreen: 195,
      },
    },
  });
};

export default AdronTheme;
